/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeboxing a daily standup meeting to keep updates brief.`)
};

const es_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acotar el tiempo de una reunión diaria de pie para mantener las actualizaciones breves.`)
};

const de_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein tägliches Standup-Meeting zeitlich begrenzen, damit Updates kurz bleiben.`)
};

const nl_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een dagelijkse stand-up meeting timeboxen om updates kort te houden.`)
};

const fr_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limiter dans le temps un daily standup pour garder les points d’avancement brefs.`)
};

const it_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delimitare nel tempo uno standup meeting giornaliero per mantenere brevi gli aggiornamenti.`)
};

const pt_br2_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitar o tempo de uma daily meeting para manter as atualizações breves.`)
};

const pt_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delimitar no tempo uma reunião diária de ponto de situação para manter as atualizações breves.`)
};

const ja_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報告を短く保つため、毎日のスタンドアップミーティングを時間で区切る。`)
};

const zh_timer_u10m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为每日站会设定时间限制，让进展汇报保持简短。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u10m_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u10m_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u10m_use3", locale)
	if (locale === "en") return en_timer_u10m_use3(inputs)
	if (locale === "es") return es_timer_u10m_use3(inputs)
	if (locale === "de") return de_timer_u10m_use3(inputs)
	if (locale === "nl") return nl_timer_u10m_use3(inputs)
	if (locale === "fr") return fr_timer_u10m_use3(inputs)
	if (locale === "it") return it_timer_u10m_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u10m_use3(inputs)
	if (locale === "pt") return pt_timer_u10m_use3(inputs)
	if (locale === "ja") return ja_timer_u10m_use3(inputs)
	return zh_timer_u10m_use3(inputs)
};